import * as REDUX_TYPES from '../types'

export const setCreditsToPurchase = (creditsToPurchase) => {
  return {
    type: REDUX_TYPES.PURCHASE.CREDITS_TO_PURCHASE,
    creditsToPurchase,
  }
}
export const setPricingTable = (pricingTable) => {
  return {
    type: REDUX_TYPES.PURCHASE.PRICING_TABLE,
    pricingTable,
  }
}

export const setTransactionType = (transactionType) => {
  return {
    type: REDUX_TYPES.PURCHASE.SET_TRANSACTION_TYPE,
    transactionType,
  }
}
